import { mixed, number, object, } from 'yup';
const penalty = () => number().typeError(`Must be a number`).integer().min(0).max(100).required();
// Upper bounds keep the int4 columns safe and the UI sane (100 years of days / months)
const positiveInt = (max = 36500) => number().typeError(`Must be a number`).integer().min(1).max(max).required();
/** Returns the first problem with the bands, or null when they are valid */
export function creditScoreBandsError(bands) {
    if (!Array.isArray(bands) || bands.length < 2 || bands.length > 8) {
        return `Between 2 and 8 bands are required`;
    }
    for (const [i, band] of bands.entries()) {
        if (typeof (band === null || band === void 0 ? void 0 : band.label) !== `string` || !band.label.trim()) {
            return `Every band needs a label`;
        }
        if (!Number.isInteger(band.min) || band.min < 0 || band.min > 100) {
            return `Band minimums must be whole numbers from 0 to 100`;
        }
        if (i > 0 && band.min >= bands[i - 1].min) {
            return `Band minimums must go down from top to bottom`;
        }
    }
    if (bands[bands.length - 1].min !== 0) {
        return `The last band must start at 0`;
    }
    return null;
}
// yup 1.x cannot type array(object(...)) with required keys inside an ObjectSchema<T>, so bands are checked by hand
const bandsSchema = mixed().required()
    .test(`bands`, ({ value }) => { var _a; return (_a = creditScoreBandsError(value)) !== null && _a !== void 0 ? _a : `Invalid bands`; }, value => creditScoreBandsError(value) === null)
    .transform(value => Array.isArray(value)
    ? value.map((b) => ({ min: b.min, label: typeof b.label === `string` ? b.label.trim() : b.label }))
    : value);
export const creditScoreConfigSchema = object({
    timingMaxPenalty: penalty(),
    timingMaxDays: positiveInt(),
    overdueRatioMaxPenalty: penalty(),
    overdueAgeMaxPenalty: penalty(),
    overdueAgeCapDays: positiveInt(),
    bands: bandsSchema,
    recencyHalfLifeDays: positiveInt(),
    paymentHistoryMonths: number().typeError(`Must be a number`).integer().min(1).max(1200).nullable().defined(),
});
//# sourceMappingURL=creditScore.js.map